var scope_0 = require('/home/juro/projects/open-a11y/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bccec82dae8821d78ab706f8aab4aada.js').default;
var scope_1 = require('/home/juro/projects/open-a11y/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ca28797624289caa60917149512cb314.js').default;
var scope_2 = require('/home/juro/projects/open-a11y/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    